import axios from "axios";
import React, { useEffect, useState } from "react";
import { BaseUrl } from "../../../Api/BaseUrl";
import { Button, Col, Container, Label, Row } from "reactstrap";
import { useQuery } from "react-query";
import { getPaymentUser } from "../../../Api/AdminApis";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomSpinner from "../../../Components/CustomElements/Spinner/SpinnerCustom";

interface Item {
  itemId: string;
  amount: string;
  comAmt: string;
}

interface CustomStyle {
  PRIMARY_COLOR_CODE: string;
  SECONDARY_COLOR_CODE: string;
  BUTTON_COLOR_CODE_1: string;
  BUTTON_COLOR_CODE_2: string;
}

interface Features {
  enableAbortResponse: boolean;
  enableExpressPay: boolean;
  enableInstrumentDeRegistration: boolean;
  enableMerTxnDetails: boolean;
  enableNewWindowFlow: boolean;
  payDetailsAtMerchantEnd?: boolean;
  payWithSavedInstrument?: boolean;
  showDownloadReceipt?: boolean;
}

interface ConsumerData {
  deviceId: string;
  token: string;
  returnUrl: string;
  responseHandler: (res: any) => void;
  paymentMode: string;
  merchantLogoUrl: string;
  merchantId: string;
  currency: string;
  consumerId: string;
  consumerMobileNo: string;
  consumerEmailId: string;
  txnId: string;
  items: Item[];
  customStyle: CustomStyle;
}

interface RequestJson {
  features: Features;
  consumerData: ConsumerData;
}

const PyamentCheckoutPage: React.FC = () => {
  const [paymentStatus, setPaymentStatus] = useState(false);
  const { token }: any = useParams();
  const navigate = useNavigate();

  const {
    data: user,
    error: userError,
    isLoading: userLoading,
    refetch: userListRefetch,
  }: any = useQuery([`user-details${token}`, token], () => getPaymentUser(token), {});

  const handleResponse = (res: any) => {
    if (
      res &&
      res.paymentMethod &&
      res.paymentMethod.paymentTransaction &&
      res.paymentMethod.paymentTransaction.statusCode === "0300"
    ) {
      Payment_ststus_update(res);
      // success block
    } else if (
      res &&
      res.paymentMethod &&
      res.paymentMethod.paymentTransaction &&
      res.paymentMethod.paymentTransaction.statusCode === "0398"
    ) {
      // initiated block
      Payment_ststus_update(res);
    } else {
      Payment_ststus_update(res);
      console.log(res, "err");
      setPaymentStatus(false);
      // error block
    }
  };

  const handleClick = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    check_cout();
  };

  const check_cout = () => {
    const reqJson: RequestJson = {
      features: {
        enableAbortResponse: true,
        enableExpressPay: true,
        enableInstrumentDeRegistration: true,
        enableMerTxnDetails: true,
        enableNewWindowFlow: true,
      },
      consumerData: {
        deviceId: "WEBSH2",
        token: user?.paymentDetails?.token,
        returnUrl: "",
        responseHandler: handleResponse,
        paymentMode: "all",
        merchantLogoUrl:
          "https://www.paynimo.com/CompanyDocs/company-logo-vertical.png",
        merchantId: user?.paymentDetails?.merchantId,
        currency: "INR",
        consumerId: user?.paymentDetails?.consumerId,
        consumerMobileNo: user?.paymentDetails?.consumerMobileNo,
        consumerEmailId: user?.paymentDetails?.consumerEmailId,
        txnId: user?.paymentDetails?.txnId,
        items: [
          {
            itemId: "first",
            amount: (user?.totalAmount ?? 0).toString(),
            comAmt: "0",
          },
        ],
        customStyle: {
          PRIMARY_COLOR_CODE: "#45beaa",
          SECONDARY_COLOR_CODE: "#FFFFFF",
          BUTTON_COLOR_CODE_1: "#2d8c8c",
          BUTTON_COLOR_CODE_2: "#FFFFFF",
        },
      },
    };
    console.log(reqJson, "resss");
    (window as any).$.pnCheckout(reqJson);
    if (reqJson.features.enableNewWindowFlow) {
      (window as any).pnCheckoutShared.openNewWindow();
    }
  };

  useEffect(() => {
    if (user?.success === false) {
      // Check for specific error types
      if (user?.payment_expired) {
        toast.error(
          user?.message || "Payment link has expired. Please contact admin to resend the payment link.",
          { autoClose: 7000 }
        );
      } else if (user?.order_expired) {
        toast.error(
          user?.message || "Membership order validity has expired. Please contact admin.",
          { autoClose: 7000 }
        );
      } else if (user?.already_paid) {
        toast.error(
          user?.message || "This membership order has already been paid.",
          { autoClose: 5000 }
        );
      } else {
        toast.error(
          user?.message || "Payment link expired please contact Admin",
          { autoClose: 5000 }
        );
      }
      navigate("/");
    }
  }, [user, navigate]);

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src =
      "https://www.paynimo.com/paynimocheckout/client/lib/jquery.min.js";
    script1.type = "text/javascript";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src =
      "https://www.paynimo.com/paynimocheckout/server/lib/checkout.js";
    script2.type = "text/javascript";
    document.head.appendChild(script2);

    return () => {
      document?.head?.removeChild(script1);
      document?.head?.removeChild(script2);
    };
  }, []);
  
  const Payment_ststus_update = async (data: any) => {
    try {
      const response = await axios.post(`${BaseUrl}/payment/order-update/${token}`,
        data
      );
      if (response?.data?.success === true) {
        if (response?.data?.data?.renewal_status === 1) {
          toast.success(
            <span className="text-center">
              Membership Renewed! <br />
              Your Membership No: <b>{response?.data?.data?.membership_no}</b>
            </span>,
            {
              delay: 3000,
            }
          );
          navigate("/member/dashboard");
        }
        console.log("success", response);
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      console.log("error ");
    }
  };

  const calculateTotalAmount = () => {
    if (user?.membershipOrder?.renewal_status === 1 && user?.fineAmount > 0) {
      return user?.totalAmount;
    }
    return user?.membershipOrder?.total_amount;
  };

  return (
    <section className="login-wrapper">
      <Container>
        <Row className="align-items-center justify-content-center p-sm-2 p-5">
          <Col md={6}>
            <div className="logo-content-wrap cssanimation sequence fadeInBottom">
              <h2>Membership Payment</h2>
              <p>Complete your membership payment securely</p>
            </div>
          </Col>
          <Col md={4}>
            <div className="login-form-wrap">
              <div className="heading">
                <h3>Payment Details</h3>
              </div>

              {userLoading ? (
                <div className="text-center py-4">
                  <CustomSpinner />
                </div>
              ) : user && user?.membershipOrder ? (
                <div className="form-wrap">
                  <Row className="g-3">
                    <Col lg={12}>
                      <div className="payment-info">
                        <div className="info-row">
                          <Label className="info-label">Member Name:</Label>
                          <span className="info-value">
                            {user?.membershipOrder?.user?.first_name}{" "}
                            {user?.membershipOrder?.user?.last_name}
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="payment-info">
                        <div className="info-row">
                          <Label className="info-label">Phone Number:</Label>
                          <span className="info-value">
                            {user?.membershipOrder?.user?.member?.phone_no}
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="payment-info">
                        {user?.membershipOrder?.renewal_status === 1 ? (
                          user?.fineAmount > 0 ? (
                            <>
                              <div className="info-row">
                                <Label className="info-label">
                                  Renewal Amount:
                                </Label>
                                <span className="info-value">
                                  ₹{user?.membershipOrder?.total_amount}
                                </span>
                              </div>
                              <div className="info-row">
                                <Label className="info-label">Fine Amount:</Label>
                                <span className="info-value">
                                  ₹{user?.fineAmount}
                                </span>
                              </div>
                              <div className="info-row total-row">
                                <Label className="info-label">
                                  Total Payable:
                                </Label>
                                <span className="info-value total-amount">
                                  ₹{user?.totalAmount}
                                </span>
                              </div>
                            </>
                          ) : (
                            <div className="info-row total-row">
                              <Label className="info-label">
                                Renewal Amount:
                              </Label>
                              <span className="info-value total-amount">
                                ₹{user?.membershipOrder?.total_amount}
                              </span>
                            </div>
                          )
                        ) : (
                          <div className="info-row total-row">
                            <Label className="info-label">
                              New Membership Amount:
                            </Label>
                            <span className="info-value total-amount">
                              ₹{user?.membershipOrder?.total_amount}
                            </span>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md={12}>
                      <Button id="btnSubmit" onClick={handleClick} disabled={paymentStatus || !user?.totalAmount || user?.totalAmount <= 0} className="sm submit-btn w-100">Pay ₹{calculateTotalAmount()}</Button>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div className="text-center py-4">
                  <p>No payment details available</p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PyamentCheckoutPage;
